// The "previous page" button of a multi-page form. It cannot be a submit button: it has to send
// the form without running the validators of the current page, which is what formnovalidate
// together with a plain submit() does.
//
// This used to be an onclick attribute in Form/Navigation.html, and it moved here for two reasons.
// An inline handler cannot be covered by a Content-Security-Policy nonce, so it would stop working
// silently under the site's policy. And the form identifier was interpolated into a JavaScript
// string literal, a context HTML escaping does not protect: the HTML parser turns &#039; back into
// an apostrophe before the JavaScript parser sees the line.
//
// The identifier is gone from the markup entirely now. The old handler looked the form up with
// document.forms['<identifier>'], which resolves against a form's name or id - but EXT:form renders
// neither: the id is "<identifier>-<contentElementUid>", so the lookup returned undefined and the
// button threw a TypeError instead of submitting. closest() walks up from the button that was
// actually clicked, which is both correct and independent of how EXT:form names things.
const buttons = document.querySelectorAll<HTMLElement>('[data-form-previous]');

buttons.forEach((button) => {
    button.addEventListener('click', () => {
        button.closest('form')?.submit();
    });
});

// This file only runs for its side effect; the empty export marks it as a module.
export {};
